function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { capitalize } from "../utils-mjs";
import { _utilsInflectorCamelize as camelize } from "miragejs";
export function adaptRecord(record) {
  if (record == null) return;
  var attrs = record.attrs,
      associations = record.associations;

  var __typename = capitalize(camelize(record.modelName));

  var clone = _objectSpread(_objectSpread({}, attrs), {}, {
    __typename: __typename
  });

  for (var field in associations) {
    clone[field] = record[field];
  }

  return clone;
}
export function adaptRecords(records) {
  return records.reduce(function (adaptedRecords, record) {
    return [].concat(adaptedRecords, [adaptRecord(record)]);
  }, []);
}
export function getRecords(type, args, mirageSchema) {
  var collectionName = mirageSchema.toCollectionName(type.name);
  var records = mirageSchema[collectionName].where(args).models;
  return adaptRecords(records);
}
export function filterRecords(records, args) {
  if (args) {
    records = records.filter(function (record) {
      return Object.keys(args).reduce(function (isMatch, arg) {
        return !isMatch ? isMatch : record[arg] === args[arg];
      }, true);
    });
  }

  return adaptRecords(records);
}
